import { ITargetDocument, SourceDocumentType } from '../../types';
import { Row } from '@tanstack/react-table';

interface ICatalogSelectField<T extends { id: number; documentType?: string }> {
  handleChange: (doc: ITargetDocument, type?: SourceDocumentType) => void;
  record: Row<T>;
  checked: boolean;
  type: 'radio' | 'checkbox';
}

export const CatalogSelectField = <T extends { id: number; documentType?: string }>({
  handleChange,
  record,
  checked,
  type,
}: ICatalogSelectField<T>) => {
  return (
    <div className="px-1">
      <input
        {...{
          type,
          checked,
          disabled: !record.getCanSelect(),
          onChange: () =>
            handleChange(
              record.original as unknown as ITargetDocument,
              record.original.documentType as SourceDocumentType,
            ),
        }}
      />
    </div>
  );
};
